import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=43c09b61&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=js&"
export * from "./SortIcon.vue?vue&type=script&lang=js&"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=43c09b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c09b61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c09b61')) {
      api.createRecord('43c09b61', component.options)
    } else {
      api.reload('43c09b61', component.options)
    }
    module.hot.accept("./SortIcon.vue?vue&type=template&id=43c09b61&scoped=true&", function () {
      api.rerender('43c09b61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/SortIcon.vue"
export default component.exports